export default {
  cities: state => state.cities,
  states: state => state.states,
  units: state => state.units,
  accessories: state => state.accessories,
  cess: state => state.cess,
  cessGeneralDuty: state => state.cessGeneralDuty,
  containerSealTypes: state => state.containerSealTypes,
  containerSizes: state => state.containerSizes,
  containerTypes: state => state.containerTypes,
  countries: state => state.countries,
  currencies: state => state.currencies,
  declarations: state => state.declarations,
  rodteps: state => state.rodteps,
  endUses: state => state.endUses,
  exporterTypes: state => state.exporterTypes,
  exportUnders: state => state.exportUnders,
  goodsStuffedAt: state => state.goodsStuffedAt,
  gstInTypes: state => state.gstInTypes,
  igstPaymentStatus: state => state.igstPaymentStatus,
  natureOfCargo: state => state.natureOfCargo,
  sealTypes: state => state.sealTypes,
  shipmentTypes: state => state.shipmentTypes,
  districtCodes: state => state.districtCodes,
  documentTypeCodes: state => state.documentTypeCodes,
  showFOBIns: state => state.showFOBIns,
  natureOfPayments: state => state.natureOfPayments,
  termsOfInvoices: state => state.termsOfInvoices,
  unitPriceIncludes: state => state.unitPriceIncludes,
  ritcCodes: state => state.ritcCodes,
  eximSchemeCodes: state => state.eximSchemeCodes,
  foreignPorts: state => state.foreignPorts,
  homePorts: state => state.homePorts,
  ptaFtas: state => state.ptaFtas,
  drawbackRates: state => state.drawbackRates,
  esanchitSupportingDocs: state => state.esanchitSupportingDocs
};
